import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: 'img[fallbackSrc]'
})
export class FallbackImageDirective implements OnInit {
  @Input() fallbackSrc: string | undefined;
  @Input() secondaryFallback: string | undefined;

  private applied = false;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  ngOnInit(): void {
    const img = this.el.nativeElement;
    // Migliora compatibilità con host che bloccano referrer
    if (!img.getAttribute('referrerpolicy')) {
      img.setAttribute('referrerpolicy', 'no-referrer');
    }
    // NOTA: loading="lazy" rimosso — su Safari 17 impedisce il firing dell'evento
    // error per immagini fuori viewport, rendendo inutile il fallback.
    // Impostare loading="lazy" esplicitamente nel template dove necessario.

    // Fix Safari 17: se l'immagine ha già fallito prima che la direttiva fosse
    // inizializzata (img.complete=true ma naturalWidth=0), l'evento error
    // non ri-scatta. Lo gestiamo manualmente qui.
    // Guardia: se src è vuota il browser la risolve alla URL della pagina corrente,
    // il che farebbe scattare il check in modo prematuro prima che Angular
    // abbia impostato il binding [src] reale, portando applied=true e impedendo
    // poi il fallback sull'errore reale.
    if (img.complete && img.naturalWidth === 0 && img.src && img.src !== window.location.href) {
      this.onError(new Event('error'));
    }
  }

  @HostListener('load')
  onLoad(): void {
    // Reset del flag dopo un caricamento riuscito: se Angular aggiorna [src]
    // con un'immagine che non esiste, il prossimo evento error potrà
    // applicare nuovamente il fallback.
    this.applied = false;
  }

  @HostListener('error', ['$event'])
  onError(_: Event): void {
    // Evita loop infinito: applica una sola volta 
    if (this.applied) { return; }
    this.applied = true;
    const img = this.el.nativeElement;
    // Disattiva ulteriori error handler
    img.onerror = null;
    const version = sessionStorage.getItem('version');
    const defaultLogo = `assets/custom/${version}/images/logo_tour_operator.png`;
    img.src = this.fallbackSrc || this.secondaryFallback || defaultLogo;
  }
}